/* global $:false */

import { DEV_MODE } from './cob.devmode.js';

/* eslint-disable prefer-rest-params */
var PubSub = function(options){
    const busName = `bus-${Math.floor(Math.random() * 10000000).toString(16)}`
    const bus = $({ name: busName});

    const { deprecatedEvents } = options || {};

    const unNamespace = function(name){
       return name.replace(/\./g, '_');
    }

    return {
        subscribe: function() {
            arguments[0] = unNamespace(arguments[0]);
            const eventName = arguments[0];
            if(deprecatedEvents && deprecatedEvents[eventName]) {
               window.console.warn('tried to subscribe to deprecated event', eventName, 'please change to', deprecatedEvents[eventName])
               bus.on(deprecatedEvents[eventName], arguments[1]);
            } else {
               bus.on.apply(bus, arguments);
            }
        },
        unsubscribe: function() {
            arguments[0] = unNamespace(arguments[0]);
            const eventName = arguments[0];
            if(deprecatedEvents && deprecatedEvents[eventName]) {
               window.console.warn('tried to unsubscribe to deprecated event', eventName, 'please change to', deprecatedEvents[eventName])
               bus.off(deprecatedEvents[eventName], arguments[1]);
            } else {
               bus.off.apply(bus, arguments);
            }
        },
        publish: function() {
            arguments[0] = unNamespace(arguments[0]);
            DEV_MODE && window.console.debug("sending event", arguments[0], arguments[1]);
            bus.trigger.apply(bus, arguments);
        }
    };
};

export default PubSub;
